





































import Vue from 'vue';
import CheckboxBlankOutlineIcon from 'vue-material-design-icons/CheckboxBlankOutline.vue';
import CheckboxMarkedOutlineIcon from 'vue-material-design-icons/CheckboxMarkedOutline.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
    CheckboxBlankOutlineIcon,
    CheckboxMarkedOutlineIcon,
  },

  props: {
    question: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      filterReports: true,
      pushingReports: false,
    };
  },

  computed: {
    filteredReports: function() {
      if (this.filterReports) {
        return this.question.reports.filter((report: any) => !report.done);
      } else {
        return this.question.reports;
      }
    },
  },

  methods: {
    toggleReportDone: async function(report: any) {
      let reportId = report.id;
      let newState = !report.done;
      await this.$store.dispatch('TOGGLE_REPORT_DONE', { reportId, newState });
      report.done = !report.done;
    },
    dateFormatter: function(dateString: string) {
      return dateString.split('T')[0];
    },
    solveAllReports: async function() {
      this.pushingReports = true;
      let unsolvedReports = this.question.reports.filter(
        (report: any) => !report.done,
      );
      await this.$store.dispatch('SOLVE_MULTIPLE_REPORTS', unsolvedReports);
      this.question.reports.map((report: any) => {
        report.done = true;
        return report;
      });
      this.pushingReports = false;
    },
  },
});
